export const updateUser = `
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      accountClaimId
      disableReplyNotifications
      emailAddress
      enableJobNotifications
      id
      lastNotificationCheck
      isScopedUser
      scopedPolicy
      recognitionEvents {
        currentBudget
        amountPending
        additionalBudgetTotal
        hasSeenPopup
        lastUpdated
        eventList {
          adminOverride
          approvalResult
          budgetAfterTotal
          budgetBeforeTotal
          completedById
          completedDate
          createdDate
          pendingApproval
          recognitionAmount
          recognitionId
          recognitionName
          sentById
          sentByManager
          sentReason
          snappyCampaignTierId
          snappyGrantId
        }
      }
    }
  }
`;
